import { inject, Injectable } from '@angular/core';
import { DashboardApiService } from '@core/api/dashboard-api.service';
import {
  DashboardConfig,
  DashboardConfigSchema,
} from '@root/app/services/dashboard-config/dashboard-charts-config.schema';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardConfigService {
  private _customApi = inject(DashboardApiService);

  private config!: DashboardConfig;

  private Notify = inject(NzNotificationService);

  async load(): Promise<void> {
    this.Notify.remove();
    let raw: unknown;

    try {
      raw = await firstValueFrom(this._customApi.getDashboardTemplate());
    } catch (e) {
      console.error('Failed to load dashboard config file', e);
      this.Notify.error(
        'Error',
        'Dashboard config file is missing or unreachable. Please contact the administrator.'
      );
      throw new Error('Dashboard config file is missing or unreachable');
    }

    const parsed = DashboardConfigSchema.safeParse(raw);

    if (!parsed.success) {
      const errors = parsed.error.issues.map((issue) => ({
        path: issue.path.join('.'),
        message: issue.message,
      }));

      console.error('Dashboard config schema validation failed:', errors);
      this.Notify.error(
        'Error',
        'Dashboard config schema validation failed. Please contact the administrator.'
      );
      throw new Error('Dashboard config JSON does not match required schema');
    }

    this.config = parsed.data;
  }

  public getConfig() {
    return this.config;
  }
}
